import { SpecificPromoCodeTerms } from 'components/terms-and-conditions-drawers/promo-code-terms/types'

export const PROMO_CODE_KEY_MAPPING: Record<string, SpecificPromoCodeTerms> = {
  '40BAW26': {
    nl: ['De korting is niet beschikbaar voor de Plenty-producten.'],
    fr: ['La remise n’est pas disponible pour les produits Plenty.']
  },
  '35BAW25': {
    nl: ['De korting is niet beschikbaar voor de Plenty-producten.'],
    fr: ['La remise n’est pas disponible pour les produits Plenty.']
  }
}
